import {PricingItem} from "../../../../domain/in/quote/pricing-item/pricing-item";
import {TranslationServiceInterface} from "../../../translation-service.interface";
import {getAmountWithCurrency} from "../../../../utils/string-utils";

export class MappingContext {

    constructor(
        private readonly translationService: TranslationServiceInterface,
        readonly currency: string,
        readonly locale: string
    ) {
    }

    translate(key: string): Promise<string> {
        return this.translationService.translate(key, this.locale);
    }

    formatAmount(value: string | undefined): string {
        return value ? getAmountWithCurrency(value, this.currency, this.locale) : '';
    }

    async getFrequency(pricingItem: PricingItem): Promise<string> {
        if (pricingItem.userInputs?.frequency?.value) {
            return this.translate('FREQUENCY_' + pricingItem.userInputs.frequency.value.toUpperCase());
        }
        return '';
    }

    async resolveCodeElis(codeElis: string | undefined): Promise<string> {
        if (!codeElis) {
            return this.translate('LABEL_ELIS_CODE_NOT_FOUND');
        }
        const numValue = Number(codeElis);
        if (!Number.isNaN(numValue) && numValue <= 0) {
            return this.translate('LABEL_ELIS_CODE_NOT_FOUND');
        }
        return codeElis;
    }
}
